var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 2.66699C3.71317 2.66699 2.6665 3.71366 2.6665 5.00033C2.6665 6.28699 3.71317 7.33366 4.99984 7.33366C6.2865 7.33366 7.33317 6.28699 7.33317 5.00033C7.33317 3.71366 6.2865 2.66699 4.99984 2.66699ZM4.99984 6.00033C4.4465 6.00033 3.99984 5.55366 3.99984 5.00033C3.99984 4.44699 4.4465 4.00033 4.99984 4.00033C5.55317 4.00033 5.99984 4.44699 5.99984 5.00033C5.99984 5.55366 5.55317 6.00033 4.99984 6.00033ZM10.9998 8.66699C9.71317 8.66699 8.6665 9.71366 8.6665 11.0003C8.6665 12.287 9.71317 13.3337 10.9998 13.3337C12.2865 13.3337 13.3332 12.287 13.3332 11.0003C13.3332 9.71366 12.2865 8.66699 10.9998 8.66699ZM10.9998 12.0003C10.4465 12.0003 9.99984 11.5537 9.99984 11.0003C9.99984 10.447 10.4465 10.0003 10.9998 10.0003C11.5532 10.0003 11.9998 10.447 11.9998 11.0003C11.9998 11.5537 11.5532 12.0003 10.9998 12.0003ZM12.8598 3.14033C13.1198 3.40033 13.1198 3.82033 12.8598 4.08033L4.07984 12.8603C3.81984 13.1203 3.39984 13.1203 3.13984 12.8603C2.87984 12.6003 2.87984 12.1803 3.13984 11.9203L11.9198 3.14033C12.1798 2.88033 12.5998 2.88033 12.8598 3.14033Z",
    fill: "#004D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentRounded);
export default __webpack_public_path__ + "static/media/PercentRounded.3e95d2c2c41f4db79a4f57bf5f666a42.svg";
export { ForwardRef as ReactComponent };